import { Link } from "react-router-dom";
import { useLocalize } from "../hooks/useLocalize";
import { profileCopy, type ProfileLanguage } from "../i18n/profile";
export const Footer = () => {
  const { language, strings, localizePath } = useLocalize();
  const copy = profileCopy[language as ProfileLanguage] || profileCopy.en;
  return <footer className="site-footer section-shell"><div><span>© {new Date().getFullYear()} Hasan Uzun</span><p>{copy.footer}</p></div><div className="footer-links"><Link to={localizePath("/privacy")}>{strings.menu.privacy}</Link><Link to={localizePath("/imprint")}>{strings.menu.imprint}</Link><a href="#top" aria-label="Back to top">↑</a></div></footer>;
};
